import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EnvironmentConfig, ENV_CONFIG } from '@emi/shared/models';
import * as ExtractionFeature from './extraction/extraction-reducer';
import * as CategoryFeature from './category/category-reducer';
import * as CountryFeature from './country/country-reducer';
import * as SupplierFeature from './supplier/supplier-reducer';
import * as BrandFeature from './brand/brand-reducer';
import * as AttributeFeature from './attribute/attribute-reducer';
import * as AttributeTypeFeature from './attribute-type/attribute-type-reducer';
import * as RetailerFeature from './retailer/retailer-reducer';
import * as RetailerTypeFeature from './retailer-type/retailer-type-reducer';
import * as CheckboxFeatureKey from './checkbox/checkbox-reducer';
import * as PromotionFeatureKey from './promotion/promotion-reducer'
import { EffectsModule } from '@ngrx/effects';
import { ExtractionEffects } from './extraction/extraction-effects';
import { CategoryEffects } from './category/category-effect';
import { CountryEffects } from './country/country-effects';
import { SupplierEffects } from './supplier/supplier-effects';
import { BrandEffects } from './brand/brand-effects';
import { AttributeEffects } from './attribute/attribute-effects';
import { AttributeTypeEffects } from './attribute-type/attribute-type-effects';
import { RetailerEffects } from './retailer/retailer-effects';
import { RetailerTypeEffects } from './retailer-type/retailer-type-effects';
import { PromotionEffects } from './promotion/promotion-effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      ExtractionFeature.feature.name,
      ExtractionFeature.feature.reducer
    ),
    StoreModule.forFeature(
      CategoryFeature.categoryFeatureKey,
      CategoryFeature.categoryFeature.reducer
    ),
    StoreModule.forFeature(
      CountryFeature.countryFeatureKey,
      CountryFeature.countryFeature.reducer
    ),
    StoreModule.forFeature(
      SupplierFeature.supplierFeatureKey,
      SupplierFeature.supplierFeature.reducer
    ),
    StoreModule.forFeature(
      BrandFeature.brandFeatureKey,
      BrandFeature.brandFeature.reducer
    ),
    StoreModule.forFeature(
      AttributeFeature.attributeFeatureKey,
      AttributeFeature.attributeFeature.reducer
    ),
    StoreModule.forFeature(
      AttributeTypeFeature.attributeTypeFeatureKey,
      AttributeTypeFeature.attributeTypeFeature.reducer
    ),
    StoreModule.forFeature(
      RetailerFeature.retailerFeatureKey,
      RetailerFeature.retailerFeature.reducer
    ),
    StoreModule.forFeature(
      RetailerTypeFeature.retailerTypeFeatureKey,
      RetailerTypeFeature.retailerTypeFeature.reducer
    ),
    StoreModule.forFeature(
      CheckboxFeatureKey.checkboxFeatureKey,
      CheckboxFeatureKey.checkboxFeature.reducer
    ),
    StoreModule.forFeature(
      PromotionFeatureKey.promotionFeatureKey,
      PromotionFeatureKey.promotionFeature.reducer
    ),
    EffectsModule.forFeature([CategoryEffects]),
    EffectsModule.forFeature([CountryEffects]),
    EffectsModule.forFeature([SupplierEffects]),
    EffectsModule.forFeature([BrandEffects]),
    EffectsModule.forFeature([AttributeEffects]),
    EffectsModule.forFeature([AttributeTypeEffects]),
    EffectsModule.forFeature([RetailerEffects]),
    EffectsModule.forFeature([RetailerTypeEffects]),
    EffectsModule.forFeature([ExtractionEffects]),
    EffectsModule.forFeature([PromotionEffects]),
  ],
})
export class SharedStateFiltersModule {
  static forRoot(config: EnvironmentConfig): ModuleWithProviders<SharedStateFiltersModule> {
      return {
          ngModule: SharedStateFiltersModule,
          providers: [
              {
                  provide: ENV_CONFIG,
                  useValue: config,
              },
          ],
      };
  }
}